import { ReactNode } from 'react';

import { AnalyticsData } from './AnalyticsData';
import { StyleProps } from './StyleProps';
import { Text } from './Text';

type Props = StyleProps & {
  children?: ReactNode;
  analyticsData?: AnalyticsData;
  dangerouslySetInnerHTML?: { __html: string };
  id?: string;
  tag?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: any;
};

export function H5({ tag = 'h5', ...props }: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Text tag={tag} styleAs="h5" {...props} />;
}
